import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 680B6AD6-C9AD-44D1-9228-EDDB8C242343
 * name plus-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-outline.svg
 * tags
 */
export const PlusOutlineIcon = createSvgIcon(<><path d="M4,9H9V4H15V9H20V15H15V20H9V15H4V9M11,13V18H13V13H18V11H13V6H11V11H6V13H11Z" /></>, 'PlusOutlineIcon');
export default PlusOutlineIcon